"use strict";

import $ from "jquery";
import "magnific-popup";
import "slick-carousel";

class MediaGallery
{
    constructor(container) {
        if (! $(container).length) {
            return;
        }

        $(container)
            .slick({
                cssEase: "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
                dots: true,
                infinite: false,
                slidesToShow: 1,
                speed: 640,
                lazyLoad: 'progressive',
                variableWidth: false,
                prevArrow: $('[data-media-role="gallery-prev"]'),
                nextArrow: $('[data-media-role="gallery-next"]')
            })
            .magnificPopup({
                delegate: "a",
                gallery: {
                    enabled: true
                },
                image: {
                    verticalFit: true
                },
                mainClass: 'tours-interactive-container',
                closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close"><span aria-hidden="true">&#215;</span></button>',
                autoFocusLast: true,
                callbacks: {
                    resize: function() {
                        var img = this.content.find('img');
                        if (img) {
                            img.css('max-height', parseFloat(img.css('max-height')) * 0.80);
                        }
                    },
                    open: function() {
                        var img = this.content.find('img');
                        if (img) {
                            img.css('max-height', parseFloat(img.css('max-height')) * 0.80);
                        }
                    },
                    change: function() {
                        var img = this.content.find('img');
                        if (img) {
                            img.css('max-height', parseFloat(img.css('max-height')) * 0.80);
                        }
                    }
                }
            });
    }
}

export default MediaGallery;
